import React from "react";
import { FormGroup, Label, Input, Button } from "reactstrap";
import { formOptions } from "./constants";

const BuildingStructure = ({ formData, handleChange, errors }) => {
  return (
    <>
      <FormGroup>
        <Label for="pondasi">26. Pondasi</Label>
        <Input 
          type="select" 
          name="pondasi" 
          id="pondasi" 
          value={formData.pondasi} 
          onChange={handleChange}
          className={errors.pondasi ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.kondisiOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.pondasi && <div className="invalid-feedback">{errors.pondasi}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="kolom">27. Kolom</Label>
        <Input 
          type="select" 
          name="kolom" 
          id="kolom" 
          value={formData.kolom} 
          onChange={handleChange}
          disabled={formData.pondasi === "Tidak Layak" && formData.modelRumah !== "Panggung"}
          className={errors.kolom ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.kondisiOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.kolom && <div className="invalid-feedback">{errors.kolom}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="rangkaAtap">28. Rangka Atap</Label>
        <Input 
          type="select" 
          name="rangkaAtap" 
          id="rangkaAtap" 
          value={formData.rangkaAtap} 
          onChange={handleChange}
          disabled={formData.pondasi === "Tidak Layak" && formData.modelRumah !== "Panggung"}
          className={errors.rangkaAtap ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.kondisiOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.rangkaAtap && <div className="invalid-feedback">{errors.rangkaAtap}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="plafon">29. Plafon</Label>
        <Input 
          type="select" 
          name="plafon" 
          id="plafon" 
          value={formData.plafon} 
          onChange={handleChange}
          disabled={formData.pondasi === "Tidak Layak" && formData.modelRumah !== "Panggung"}
          className={errors.plafon ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.kondisiOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.plafon && <div className="invalid-feedback">{errors.plafon}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="balok">30. Balok</Label>
        <Input 
          type="select" 
          name="balok" 
          id="balok" 
          value={formData.balok} 
          onChange={handleChange}
          disabled={formData.pondasi === "Tidak Layak" && formData.modelRumah !== "Panggung"}
          className={errors.balok ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.kondisiOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.balok && <div className="invalid-feedback">{errors.balok}</div>}
      </FormGroup>

      
    </>
  );
};

export default BuildingStructure;
